import { Box, Button, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ConvertDate, DateConvertInDbFormat } from "../../../Base/helper/baseFunctions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { UpdateApprovedEmployeeAdjustmentClearanceHelper, UpdateApprovedEmployeeAssetsClearanceHelper } from "../../helper/EmployeeClearanceHelper";
const ApprovalPopUp = ({ closeMode, mode, employeeRecord }) => {
  const [clearanceData, setClearanceData] = useState([]);
  const [adjustmentData, setAdjustmentData] = useState([]);

  const handleInput = (index, field, value) => {
    setClearanceData((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [field]: value,
      };
      return updated;
    });
  };
  const handleInputChange = (index, field, value) => {
    setAdjustmentData((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        component_json: {
          ...updated[index].component_json,
          [field]: value,  
        },
      };
      return updated;
    });
  };

  const handleSubmit = async (type) => {
    if(type === '1') {
      const today = DateConvertInDbFormat()
      const payload = clearanceData?.map(item => {
        const { employee_clearance_mapping_pk, ...rest } = item;
         return {
            ...rest,
            employee_clearance_mapping_id: employee_clearance_mapping_pk,
            approver_date:
              item.approver_status === "Yes" || item.approver_status === "No"
                ? today
                : item?.approver_date || null,
          };
      });
      UpdateApprovedEmployeeAssetsClearanceHelper({clearance_agg_component_json: JSON.stringify(payload)}).then((res) => {
        if(res?.data?.statuscode === 200) {
          closeMode('1');
        }
      })
    }
    if(type === '2') {
      const today = DateConvertInDbFormat()
      const payload = adjustmentData?.map(item => {
        const { component_json, ...rest } = item;
         return {
            ...rest,
            component_json: {
                ...component_json,
                approver_date: component_json?.approver_amount
                  ? today
                  : component_json?.approver_date || null,
                approver_status: component_json?.approver_amount
                ? "Yes"
                : null, 
                employee_ecms_adjustments_id: item?.employee_ecms_adjustments_pk,  
              },
          };
      });
      UpdateApprovedEmployeeAdjustmentClearanceHelper({ecms_adjustment_agg_component_json: JSON.stringify(payload)}).then((res) => {
        if(res?.data?.statuscode === 200) {
          closeMode('2');
        }
      })
    } 
  };

  useEffect(() => {
     if (employeeRecord?.clearances?.length > 0) {
      setClearanceData(employeeRecord?.clearances);
    }
     if (employeeRecord?.adjustments?.length > 0) {
      setAdjustmentData(employeeRecord?.adjustments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeRecord]);
  return (
    <>
      <Box>
        <Typography variant="subtitle1" fontWeight={"600"} gutterBottom>
          Employee Details
        </Typography>
        <Box
          sx={{
            px: 3,
            py: 2,
            mb: 2,
            borderRadius: 2,
            backgroundColor: "#f4f2f7",
            border: "1px solid #E0E0E0",
          }}
        >
          <Grid container spacing={1.5}>
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Employee Name
              </Typography>
              <Typography fontWeight={500}>
                {employeeRecord?.employee_name || "-"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Date of Joining
              </Typography>
              <Typography fontWeight={500}>
                {ConvertDate(employeeRecord?.doj)|| "-"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Resignation Date
              </Typography>
              <Typography fontWeight={500}>
                {ConvertDate(employeeRecord?.resignation_date) || "-"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body2" color="textSecondary">
                Last Working Date
              </Typography>
                <Typography fontWeight={500}>
                  {ConvertDate(employeeRecord?.lwd) || "-"}
                </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      { mode === '1' && clearanceData?.length > 0 && (<Grid container spacing={2}>
        {/* Section Header */}
        <Grid item xs={12}>
          <Typography variant="h6" fontWeight={600} gutterBottom>
            Asset Clearance
          </Typography>
        </Grid>
        <Grid container spacing={2} pl={5}>
          {clearanceData?.map((item, index) => (
            <Grid
               key={`clearance-${item.employee_clearance_mapping_pk}`}
              item
              xs={12}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              pl={2}
            >
            <Box display="flex" alignItems="center" justifyContent="space-between" width={"60%"}>
              <Typography variant="body1" fontWeight={500} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {item?.clearance_type}
                {(employeeRecord?.clearances[index]?.approver_status === "Yes")&& (
                      <CheckCircleIcon color="primary" fontSize="small" />
                  )}
              </Typography>
              <RadioGroup
                row
                value={item?.approver_status || ""}
                onChange={(e) =>
                  handleInput(index, "approver_status", e.target.value)
                }
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio color="primary" />}
                  label="Yes"
                  disabled={
                  employeeRecord?.clearances[index]?.approver_status === "Yes"
                }
                />
                <FormControlLabel
                  value="No"
                  control={<Radio color="primary" />}
                  label="No"
                  disabled={
                  employeeRecord?.clearances[index]?.approver_status === "Yes"
                }
                />
              </RadioGroup>
            </Box>
              <Box width={"40%"}>
                <TextField
                    placeholder="Comment"
                    value={item?.approver_comments || ""}
                    onChange={(e) => {
                    if (e.target.value.length <= 50) {
                      handleInput(index, "approver_comments", e.target.value);
                    }
                    }}
                    fullWidth
                    multiline
                    minRows={1}
                    maxRows={1}
                    variant="outlined"
                    size="small"
                    disabled={
                      employeeRecord?.clearances[index]?.approver_status === "Yes"
                    }
                    inputProps={{
                      maxLength: 50,
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        borderRadius: "5px",
                        fontSize: "14px",
                        fontFamily: "inherit",
                      },
                    }}
                  />
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    textAlign: "right",
                    color: "#888",
                  }}
                >
                  {item?.approver_comments?.length || 0}/50
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
        {/* Subsection: ID Card with Toggle */}
      </Grid>)}

      { mode === '2' &&  adjustmentData?.length > 0 && (
        <Grid container mt={"-5px"} spacing={1}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" fontWeight={600}>
              Adjustment Clearance
            </Typography>
          </Grid>

          {adjustmentData?.map((item, index) => (
            <React.Fragment key={item.employee_ecms_adjustments_pk}>
              <Grid item xs={12} mt={0.5}>
                <Typography variant="body1" fontWeight={500} gutterBottom pl={2} mb={1.5} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  {item?.component_json?.label}
                  {employeeRecord?.adjustments[index]?.component_json?.approver_status === "Yes" && (
                      <CheckCircleIcon color="primary" fontSize="small" />
                  )}
                </Typography>
              </Grid>

              <Grid container spacing={2} pl={3} pr={1}>  
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    name={`amount`}
                    label="Submitted Amount"
                    type="number"
                    size="small"
                    disabled
                    value={item?.amount || ""}
                  />
                </Grid>

                {/* Approved */}
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Approved Amount"
                    type="number"
                    size="small"
                    disabled={employeeRecord?.adjustments[index]?.component_json?.approver_status === "Yes"}
                    value={item?.component_json?.approver_amount || ""}
                    onChange={(e) =>
                      handleInputChange(index, "approver_amount", e.target.value)
                    }
                  />
                </Grid>

                {/* Comments */}
                <Grid item xs={12} md={4}>
                  <TextField
                      placeholder="Comment"
                      value={item?.component_json?.approver_comments || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value.length <= 50) {
                          handleInputChange(index, "approver_comments", value);
                        }
                      }}
                      fullWidth
                      multiline
                      minRows={1}
                      maxRows={1}
                      variant="outlined"
                      size="small"
                      disabled={
                        employeeRecord?.adjustments[index]?.component_json?.approver_status === "Yes"
                      }
                      inputProps={{
                        maxLength: 50,
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          borderRadius: "5px",
                          fontSize: "14px",
                          fontFamily: "inherit",
                        },
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{ display: "block", textAlign: "right", color: "#888" }}
                    >
                      {item?.component_json?.approver_comments?.length || 0}/50
                    </Typography>
                </Grid>
              </Grid>
            </React.Fragment>
          ))}
      </Grid>)}
      <Box sx={{ display: "flex", justifyContent: "flex-end", m: 1.5, mt: 3, gap: 2 }}>
        <Button
          variant="outlined"
          size="medium"
          onClick={closeMode}
        >
          Cancel
        </Button>
        <Button
          variant="outlined"
          size="medium"
          onClick={() => handleSubmit(mode)}
        >
          Approve
        </Button>
      </Box>
    </>
  );
};

export default ApprovalPopUp;
